import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './about-blocks.scss';

export class AboutBlocks extends PureComponent {
  render() {
    const [turq, bordered, solid] = this.props.blocks;

    return (
      <div className="about-blocks">
        <ul>
          <li>
            <div className="about-block block-turq">
              <div className="about-block-value">
                <span
                  className="block-value"
                  dangerouslySetInnerHTML={{ __html: turq.value }}
                />

                <span
                  className="block-unit"
                  dangerouslySetInnerHTML={{ __html: turq.unit }}
                />
              </div>

              <div
                className="about-block-text"
                dangerouslySetInnerHTML={{ __html: turq.text }}
              />
            </div>
          </li>
          <li>
            <div className="about-block block-bordered">
              <div className="about-block-value">
                <span
                  className="block-value"
                  dangerouslySetInnerHTML={{ __html: bordered.value }}
                />
              </div>

              <div
                className="about-block-text"
                dangerouslySetInnerHTML={{ __html: bordered.text }}
              />
            </div>

            <div className="about-block block-solid">
              <div className="about-block-value">
                <span
                  className="block-value"
                  dangerouslySetInnerHTML={{ __html: solid.value }}
                />

                <span
                  className="block-unit"
                  dangerouslySetInnerHTML={{ __html: solid.unit }}
                />
              </div>

              <div
                className="about-block-text"
                dangerouslySetInnerHTML={{ __html: solid.text }}
              />
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

AboutBlocks.propTypes = {
  blocks: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      value: PropTypes.string,
      unit: PropTypes.string,
      text: PropTypes.string
    })
  )
};

export default AboutBlocks;



// WEBPACK FOOTER //
// ./src/components/About/AboutBlocks.js